import React from 'react'
import PropTypes from 'prop-types'

import {
  title,
  description
} from './styles/Title.style'

const Title = ({ text, subtitle }) => {
  return (
    <div>
      <h1 className={title}>{text}</h1>

      {subtitle && (
        <h2 className={description}>{subtitle}</h2>
      )}
    </div>
  )
}

Title.propTypes = {
  text: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired
}

export default Title
